// import React, { useState, useEffect, useRef } from "react";
// import "./ProductDetail129.css";

// /* ── useInView hook ── */
// export function useInView(threshold = 0.12) {
//   const ref = useRef(null);
//   const [inView, setInView] = useState(false);
//   useEffect(() => {
//     const obs = new IntersectionObserver(
//       ([e]) => { if (e.isIntersecting) setInView(true); },
//       { threshold }
//     );
//     if (ref.current) obs.observe(ref.current);
//     return () => obs.disconnect();
//   }, [threshold]);
//   return [ref, inView];
// }

// /* ── useCounter hook ── */
// export function useCounter(target, duration = 2000, active = false) {
//   const [count, setCount] = useState(0);
//   useEffect(() => {
//     if (!active) return;
//     let start = null;
//     const ease = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
//     const step = ts => {
//       if (!start) start = ts;
//       const p = Math.min((ts - start) / duration, 1);
//       setCount(Math.floor(ease(p) * target));
//       if (p < 1) requestAnimationFrame(step);
//     };
//     requestAnimationFrame(step);
//   }, [active, target, duration]);
//   return count;
// }

// /* ════════════════════════════════
//    BENEFITS SECTION
// ════════════════════════════════ */
// const BENEFITS = [
//   {
//     icon: "bi-currency-rupee",
//     num: 25, suffix: "%",
//     label: "Revenue Leakage Reduced",
//     desc: "AI-powered verification eliminates manual bypass and FASTag fraud at the source.",
//     // color: "#0284c7",
//     color:"linear-gradient(135deg, #0284c7, #06b6d4)",
//     //  bg: "#e0f2fe",
//     bg:"linear-gradient(135deg, #0284c7, #06b6d4)",
//   },
//   {
//     icon: "bi-lightning-charge-fill",
//     num: 21, suffix: "s",
//     label: "Avg. Lane Clearance Time",
//     desc: "From vehicle arrival to barrier lift — 21 seconds, consistently, every time.",
//     color: "#0369a1", bg: "#bae6fd",
//   },
//   {
//     icon: "bi-eye-fill",
//     num: 100, suffix: "%",
//     label: "Operational Transparency",
//     desc: "Every lane, every transaction, every second — fully visible from one dashboard.",
//     color: "#6d28d9", bg: "#ede9fe",
//   },
//   {
//     icon: "bi-bullseye",
//     num: 97, suffix: "%",
//     label: "Detection Accuracy",
//     desc: "AI OCR and axle detection tested and validated across all Indian vehicle classes.",
//     color: "#0f766e", bg: "#ccfbf1",
//   },
//   {
//     icon: "bi-shield-check-fill",
//     num: 0, suffix: "%",
//     label: "Undetected Fraud Attempts",
//     desc: "Multi-layer rules engine catches every suspicious transaction in real time.",
//     color: "#b45309", bg: "#fef3c7",
//   },
//   {
//     icon: "bi-buildings",
//     num: 24, suffix: "/7",
//     label: "Live Multi-Plaza Monitoring",
//     desc: "Centralized cloud dashboard active for all plaza locations simultaneously.",
//     color: "#0284c7", bg: "#e0f2fe",
//   },
// ];

// function BenefitCard({ item, index, inView }) {
//   const count = useCounter(item.num, 2000, inView);
//   return (
//     <div
//       className={`pd9-ben-card ${inView ? "pd9-ben-card--in" : ""}`}
//       style={{ animationDelay: `${index * 90}ms`, "--bc": item.color, "--bb": item.bg }}
//     >
//       <div className="pd9-ben-card__top-line" />
//       <div className="pd9-ben-card__icon-wrap">
//         <i className={`bi ${item.icon}`} />
//       </div>
//       <div className="pd9-ben-card__num">
//         {count}{item.suffix}
//       </div>
//       <div className="pd9-ben-card__label">{item.label}</div>
//       <p className="pd9-ben-card__desc">{item.desc}</p>
//     </div>
//   );
// }

// function ProductDetail130() {
//   const [secRef, inView] = useInView(0.08);
//   return (
//     <section className="pd9-benefits" ref={secRef}>
//       <div className="pd9-blob pd9-blob--tl" />
//       <div className="pd9-blob pd9-blob--br" />
//       <div className="pd9-wrap">
//         <div className={`pd9-head ${inView ? "pd9-head--in" : ""}`}>
//           <span className="pd9-eyebrow">BUSINESS IMPACT</span>
//           <h2 className="pd9-h2">Measurable Benefits <span>for Every Operator</span></h2>
//           <p className="pd9-sub">
//             Real numbers. Real results. TPMS delivers measurable ROI from day one — across every lane, plaza, and payment type.
//           </p>
//         </div>
//         <div className="pd9-ben-grid">
//           {BENEFITS.map((b, i) => (
//             <BenefitCard key={i} item={b} index={i} inView={inView} />
//           ))}
//         </div>
//         {/* Bottom highlight bar */}
//         <div className={`pd9-ben-highlight ${inView ? "pd9-ben-highlight--in" : ""}`}>
//           <i className="bi bi-quote" />
//           <p>"Our AI-powered TPMS system ensures up to <strong>97% accuracy</strong> in vehicle detection and significantly reduces operational losses."</p>
//         </div>
//       </div>
//     </section>
//   );
// }
// export default ProductDetail130;




import React, { useState, useEffect, useRef } from "react";
import "./ProductDetail130.css";

export function useInView(threshold = 0.12) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setInView(true); },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

function useCounter(target, duration = 2000, active = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = null;
    const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      setCount(Math.floor(ease(p) * target));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, target, duration]);
  return count;
}

const BENEFITS = [
  {
    icon: "bi-currency-rupee",
    num: 25, suffix: "%",
    label: "Revenue Leakage Reduced",
    desc: "AI-powered verification eliminates manual bypass and FASTag fraud at the source.",
    color: "#128596", bg: "#e0f2fe",
    grad: true,
  },
  {
    icon: "bi-lightning-charge-fill",
    num: 21, suffix: "s",
    label: "Avg. Lane Clearance Time",
    desc: "From vehicle arrival to barrier lift — 21 seconds, consistently, every time.",
     color: "#128596", bg: "#e0f2fe",
    grad: true,
  },
  {
    icon: "bi-eye-fill",
    num: 100, suffix: "%",
    label: "Operational Transparency",
    desc: "Every lane, every transaction, every second — fully visible from one dashboard.",
     color: "#128596", bg: "#e0f2fe",
    grad: true,
  },
  {
    icon: "bi-bullseye",
    num: 97, suffix: "%",
    label: "Detection Accuracy",
    desc: "AI OCR and axle detection tested and validated across all Indian vehicle classes.",
    color: "#128596", bg: "#e0f2fe",
    grad: true,
  },
  {
    icon: "bi-shield-check",
    num: 0, suffix: "%",
    label: "Undetected Fraud Attempts",
    desc: "Multi-layer rules engine catches every suspicious transaction in real time.",
    color: "#128596", bg: "#e0f2fe",
    grad: true,
  },
  {
    icon: "bi-buildings",
    num: 24, suffix: "/7",
    label: "Live Multi-Plaza Monitoring",
    desc: "Centralized cloud dashboard active for all plaza locations simultaneously.",
    color: "#128596", bg: "#094b78",
    grad: true,
  },
];

function BenefitCard({ item, index, inView }) {
  const count = useCounter(item.num, 2000, inView);
  return (
    <div
      className={`pd9-ben-card${item.grad ? " pd9-ben-card--grad" : ""} ${inView ? "pd9-ben-card--in" : ""}`}
      style={{ animationDelay: `${index * 90}ms`, "--bc": item.color, "--bb": item.bg }}
    >
      <div className="pd9-ben-card__top-line" />
      <div className="pd9-ben-card__icon-wrap">
        <i className={`bi ${item.icon}`} />
      </div>
      <div className="pd9-ben-card__num">
        {count}{item.suffix}
      </div>
      <div className="pd9-ben-card__label">{item.label}</div>
      <p className="pd9-ben-card__desc">{item.desc}</p>
    </div>
  );
}

 function ProductDetail130() {
  const [ref, inView] = useInView(0.08);

  return (
    <section className="pd9-benefits" ref={ref}>
      <div className="pd9-blob pd9-blob--tl" />
      <div className="pd9-blob pd9-blob--br" />
      <div className="pd9-wrap">

        <div className={`pd9-head ${inView ? "pd9-head--in" : ""}`}>
          <span className="pd9-eyebrow">BUSINESS IMPACT</span>
          <h2 className="pd9-h2">Measurable Benefits <span>for Every Operator</span></h2>
          <p className="pd9-sub">
            Real numbers. Real results. TPMS delivers measurable ROI from day one — across every lane, plaza, and payment type.
          </p>
        </div>

        <div className="pd9-ben-grid">
          {BENEFITS.map((b, i) => (
            <BenefitCard key={i} item={b} index={i} inView={inView} />
          ))}
        </div>

        <div className={`pd9-ben-highlight ${inView ? "pd9-ben-highlight--in" : ""}`}>
          <i className="bi bi-quote" />
          <p>"Our AI-powered TPMS system ensures up to <strong>97% accuracy</strong> in vehicle detection and significantly reduces operational losses."</p>
        </div>

      </div>
    </section>
  );
}
export default ProductDetail130;